import { c as _c } from "react/compiler-runtime";
import { Slot } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md text-sm font-medium transition-[colors,transform] duration-75 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:opacity-100 hover:[&_svg]:opacity-90 active:scale-[0.97] data-[pressed]:scale-[0.97] cursor-pointer', {
  variants: {
    variant: {
      default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90',
      destructive: 'bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90',
      outline: 'bg-background shadow-xs outline outline-border hover:bg-border hover:text-accent-foreground',
      secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
      ghost: 'hover:bg-accent hover:text-accent-foreground',
      link: 'text-primary underline-offset-4 hover:underline'
    },
    size: {
      default: 'h-9 px-4 py-2',
      sm: 'h-8 rounded-md px-3 text-xs',
      lg: 'h-10 rounded-md px-8',
      icon: 'size-9',
      tiny: 'size-5 [&_svg]:size-3'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
export type ButtonProps = {
  asChild?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>;
const Button = t0 => {
  const $ = _c(16);
  let className;
  let props;
  let ref;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      variant,
      size,
      asChild: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = size;
    $[5] = t1;
    $[6] = variant;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    size = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  let t2;
  if ($[7] !== className || $[8] !== size || $[9] !== variant) {
    t2 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[7] = className;
    $[8] = size;
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== Comp || $[12] !== props || $[13] !== ref || $[14] !== t2) {
    t3 = <Comp className={t2} ref={ref} {...props} />;
    $[11] = Comp;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
Button.displayName = 'Button';
export { Button, buttonVariants };